import { render, staticRenderFns } from "./PrincipleAdmin.vue?vue&type=template&id=172c837a&"
import script from "./PrincipleAdmin.vue?vue&type=script&lang=js&"
export * from "./PrincipleAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports